<template>
  <div>
    <v-row align="center" justify="end">
      <v-col cols="auto">
        <dropdown
          :label="$t('order_status')"
          :items="statusItems"
          v-model="orderStatus"
          hide-details
        ></dropdown>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="userOrders"
      :loading="loading"
      :loading-text="$t('loading')"
      sort-by="status"
      class="striped-table ordera-box-shadow"
      hide-default-footer
      disable-pagination
      :search="search"
    >
      <template v-slot:no-data>
        <v-container class="text-center py-12">
          <v-icon size="64" color="grey lighten-1" class="mb-4"> mdi-account-off </v-icon>
          <div class="text-h6 grey--text text--darken-1 mb-2">
            {{ $t("no_company_report_data") }}
          </div>
          <div class="text-body-2 grey--text">
            {{ $t("select_date_and_filters") }}
          </div>
        </v-container>
      </template>
      <template v-slot:item.id="{ item }">
        <span v-if="item.id == 'УКУПНО:'">{{ $t("totalU") }}</span>
        <span v-else @click.prevent="showUsers(item)">{{ item.id }} </span>
      </template>
      <template v-for="values in headers" v-slot:item.num="{ item, index }">
        {{ item.id == "УКУПНО" ? "" : index + 1 }}
      </template>
      <template v-slot:item.action="{ item }">
        <circle-button
          v-if="item.id !== 'УКУПНО:'"
          icon="mdi-format-list-bulleted"
          color="primary"
          @click="openDialogReportUser(item)"
          :tooltip="$t('tooltip_order_details')"
        />
      </template>
      <template v-slot:body.append>
        <tr class="text-weight-bold">
          <td></td>
          <td>{{ $t("totalU") }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>{{ totals.order_count || 0 }}</td>
          <td v-if="company?.checkReport">{{ totals.order_payed || 0 }}</td>
          <td v-if="company?.checkReport">
            {{ (totals.order_count || 0) - (totals.order_payed || 0) }}
          </td>
          <td></td>
        </tr>
      </template>
    </v-data-table>
    <company-report-dialog-employee v-model="employeeDialog" :employee="selected_user">
    </company-report-dialog-employee>
  </div>
</template>

<script>
import CompanyReportDialogEmployee from "@/components/company/reports/dialogs/CompanyReportDialogEmployee.vue";
import hasReportPrinting from "@/mixins/report/hasReportPrinting";
import hasPrinting from "@/mixins/hasPrinting";
import hasExcel from "@/mixins/hasExcel";
import hasOrderCalculations from "@/mixins/report/hasOrderCalculations";
import moment from "moment";

export default {
  mixins: [hasPrinting, hasExcel, hasReportPrinting, hasOrderCalculations],
  props: {
    users: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CompanyReportDialogEmployee,
  },
  data: () => ({
    search: "",
    selected_user: {},
    employeeDialog: false,
    date: [new Date().toISOString().substr(0, 10)],
  }),
  methods: {
    openDialogReportUser(item, food) {
      this.selected_user = item;
      this.employeeDialog = true;
    },
  },
  computed: {
    statusItems() {
      const baseItems = [
        { text: this.$t("all"), value: 0 },
        { text: this.$t("users_ordered"), value: 1 },
        { text: this.$t("not_ordered"), value: 2 },
      ];
      if (this.company?.checkReport) {
        baseItems.push({ text: this.$t("users_ordered_not_taken"), value: 3 });
      }

      return baseItems;
    },
    company() {
      return this.$store.state.company;
    },
    userOrders() {
      // Process users using mixin method
      const processedUsers = this.processUsersOrderData(this.users);

      // Filter users by status using mixin method
      const filteredUsers = this.filterUsersByStatus(processedUsers, this.orderStatus);

      return filteredUsers.map((user) => {
        return {
          ...user,
          name: this.toLatin(user.name),
          lastname: this.toLatin(user.lastname),
          order_date: (user.orders || []).length
            ? moment(user.orders[0].created_at).format("DD.MM.YYYY HH:mm")
            : null,
        };
      });
    },
    headers() {
      const headers = [
        { text: this.$t("r_b"), value: "num" },
        { text: "ID", value: "id" },
        { text: this.$t("external_code"), value: "external_code" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("last_name"), value: "lastname" },
        {
          text: this.$t("order_time"),
          value: "order_date",
          sort: (a, b) => {
            if (!a || !b) return 0;
            const dateA = moment(a, "DD.MM.YYYY HH:mm").toDate();
            const dateB = moment(b, "DD.MM.YYYY HH:mm").toDate();
            return dateA - dateB;
          },
        },
        { text: this.$t("ordered"), value: "order_count" },
        { text: this.$t("report"), value: "action", print: false },
      ];
      if (this.company?.checkReport) {
        headers.splice(
          6,
          0,
          { text: this.$t("taken"), value: "order_payed" },
          { text: this.$t("difference"), value: "difference" }
        );
      }
      return headers;
    },
    selectedCompanies() {
      return this.$store.state.report.selectedFoodCompanies
        .map((company) => this.toLatin(company?.name || ""))
        .join(", ");
    },
    totals() {
      return this.userOrders.reduce(
        (acc, user) => {
          acc.order_count += user.order_count || 0;
          acc.order_payed += user.order_payed || 0;
          return acc;
        },
        { order_count: 0, order_payed: 0 }
      );
    },
  },
  watch: {
    isPrinting() {
      if (this.isPrinting) {
        this.printDocument({
          tables: [
            {
              headers: this.headers,
              items: this.users,
            },
          ],
          title: [this.$t("report"), this.$t("user_overview").toLowerCase()].join(" "),
          subtitle: this.subtitle,
          beforeTableHtml: `<h4 style="text-align: center">${this.selectedCompanies}</h4>`,
        });
      }
    },
    isExcelDownloading() {
      if (this.isExcelDownloading) {
        this.downloadExcel({
          fileName: [this.$t("report"), this.$t("user_overview")].join(" ") + ".xlsx",
          sheets: [
            {
              name: this.$t("user_overview"),
              headers: this.headers,
              items: this.users,
              title: [this.$t("report"), this.$t("user_overview").toLowerCase()].join(
                " "
              ),
              subtitle: this.subtitle,
              beforeTableHtml: `<h4 style="text-align: center">${this.selectedCompanies}</h4>`,
            },
          ],
        });
      }
    },
  },
};
</script>
